var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weight-balance-container"},[_c('HiloChart',{attrs:{"xFrom":_vm.xFrom,"xTo":_vm.xTo,"yFrom":_vm.yFrom,"yTo":_vm.yTo,"datasets":[..._vm.datasets, ..._vm.lines]}}),_c('div',[_c('button',{staticClass:"primary",on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v("Next")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }